import {Base} from "@/api/Base"

export class PaymentGetLastPayment extends Base {
    path = "payment/getLastPayment"
}